// © Microsoft Corporation. All rights reserved.

/**
 * Used to define how an experience is related to monetization scenarios
 * that need to be accounted when selecting a certain section template.
 * e.g.: monetization child experiences will need to be turned off in the river
 * when non-monetizable experiences start being returned from OneService.
 */
export enum MonetizationPlacementOptions {
    /**
     * e.g.: ContentPreview, when used for cms content
     */
    Monetizable,
    /**
     * e.g.: ExternalContentPreview, when used for webcontent
     */
    NonMonetizable,
    /**
     * e.g.: DisplayAd, NativeAd or EditorChoicePromoCard (when sponsored content)
     */
    Monetization
}